import dayjs, { type Dayjs } from 'dayjs';

import { DATE, weekdayIndex } from '../Calendar/types';

// The club whose schedule is shown.
export interface ScheduleClub {
  id: number;
  start_date: string | null;
  // The weekdays it meets: 1 = Monday … 7 = Sunday.
  week_days: number[];
}

// club_schedule: a Club month and its Session dates (CONTEXT.md).
export interface ClubMonth {
  id: number;
  name: string;
  start_date: string;
  end_date: string;
  dates: string[];
}

export interface Holiday {
  date: string;
  title: string;
}

export interface ClubScheduleData {
  months: ClubMonth[];
  holidays: Holiday[];
}

// "2026 оны 9-р сар", from a month's start date.
export const defaultMonthName = (start: Dayjs) => `${start.year()} оны ${start.month() + 1}-р сар`;

// The next Club month's dates: the day after the last one ends (or the club's
// start date, or today), for a month less a day.
export function nextMonthRange(club: ScheduleClub, months: ClubMonth[]): [Dayjs, Dayjs] {
  const last = months[months.length - 1];
  const start = last
    ? dayjs(last.end_date).add(1, 'day')
    : dayjs(club.start_date ?? undefined).startOf('day');
  return [start, start.add(1, 'month').subtract(1, 'day')];
}

// Every date in [from, to] on one of the weekdays, skipping Holidays.
export function datesOnWeekdays(
  from: string,
  to: string,
  weekDays: number[],
  holidays: Set<string>,
): string[] {
  const dates: string[] = [];
  for (let d = dayjs(from); !d.isAfter(dayjs(to)); d = d.add(1, 'day')) {
    const date = d.format(DATE);
    if (weekDays.includes(weekdayIndex(d) + 1) && !holidays.has(date)) dates.push(date);
  }
  return dates;
}

export const formatRange = (from: string, to: string) =>
  `${dayjs(from).format('YYYY.MM.DD')} – ${dayjs(to).format('YYYY.MM.DD')}`;
